<template>
  <div class="box">
    <div class="head">
      港珠澳大橋穿梭巴士-員工後臺管理系統
      <!--<span class="size" @click="logout">簡體</span>-->
    </div>
    <div class="centent">
      <div class="logo_box">
        <div class="box_name">登錄</div>

        <div class="input_div">
          <img src="./images/user_name.png" alt="">
          <input @keyup.enter="login" type="text" placeholder="賬號" v-model="accountId">
        </div>

        <div class="input_div">
          <img src="./images/user_psd.png" alt="">
          <input @keyup.enter="login" type="password" placeholder="密碼" v-model="password">
        </div>
        <div class="auth_code" v-if="codeImg!==''">
          <input type="text" placeholder="驗證碼" v-model="authCode">
          <img :src="codeImg" alt="點擊刷新" @click="refreshCode">
        </div>
        <div class="forget_account">
          <span class="pane" :class="isMind?'right':''" @click="isMind=!isMind"></span>
          <span>記住賬號</span>
          <!--<span class="forget_pad">忘記密碼？</span>-->
        </div>
        <div class="button" @click="login">登錄</div>
        <!--<div class="apply_for">
            沒有賬號？
            <span>馬上申請</span>
        </div>-->
      </div>
    </div>
    <div class="bottom_box">
      <div class="hint">
        <span class="name">電話</span>
        <span>400-6880089</span>
        <!--        <span class="vertical">|</span>-->
        <!--        <span class="name">郵箱</span>-->
        <!--        <span>marketing@hzmbus.com</span>-->
        <span class="vertical">|</span>
        <span class="name">技術支持</span>
        <span>和方科技</span>
      </div>
      <div class="hint" @click="goRecord">粵ICP備18047137號</div>
    </div>
  </div>
</template>
<script>
export default {
  data: function() {
    return {
      accountId: '',
      password: '',
      isMind: false,
      codeImg: '',
      authCode: '',
      localStorageAccountId: "hzmbPersonnelAccountId",
    }
  },
  created()
  { //頁面加載後執行
    //記住賬號
    if(window.localStorage.getItem(this.localStorageAccountId))
    {
      this.accountId = window.localStorage.getItem((this.localStorageAccountId));
      this.isMind = true;
    }
  },
  methods: {
    refreshCode()
    {
      this.codeImg = this.IP + this.PATH + '/captcha?random=' + Math.random();
    },
    login()
    {
      if(this.isMind)
      {
        window.localStorage.setItem(this.localStorageAccountId, this.accountId);
      }
      else
      {
        if(window.localStorage.getItem(this.localStorageAccountId))
        {
          window.localStorage.removeItem(this.localStorageAccountId);
        }
      }
      let parameter = {
        companyCode: this.accountId,
        companyPwd: this.password,
      };
      if(this.authCode !== '')
      {
        parameter.code = this.authCode;
      }
      this.$dialog.loading.open();
      this.axios.post(this.IP + this.PATH + '/login', parameter).then(response => {
        this.$dialog.loading.close();
        if(response.data.code === "SUCCESS" && response.data.responseData.ret === 0)
        {
          //獲取 jwt
          this.$store.commit('token', response.data.jwt);
          //保存用戶信息
          this.$store.commit('setUserInfo', response.data.responseData);
          // window.sessionStorage.setItem('token', response.data.jwt);
          window.localStorage.setItem('token', response.data.jwt);
          //保存管理員ID和名稱
          this.setCookie("admin_name", response.data.responseData.company_name_ch);//管理員名稱
          this.setCookie("accountId", response.data.responseData.company_code)//管理員ID
          this.$notify({title: '成功', message: '登錄成功', type: 'success'});
          this.$router.push({name: 'personnel_manage'});
        }
        else
        {
          if(response.data.needcode === true)
          {//登錄失敗三次，輸驗證碼
            this.codeImg = this.IP + this.PATH + '/captcha?random=' + Math.random();
          }
          if(response.data.code === 'FAIL')
          {
            this.$notify({title: '警告', message: response.data.message, type: 'warning'});
            this.$dialog.loading.close();
          }

          if(response.data.responseData.ret !== 0)
          {
            this.$notify({title: '警告', message: response.data.responseData.errmsg, type: 'warning'});
            this.$dialog.loading.close();
          }

          // else if(response.data.code === 'ERROR_PWD')
          // {//密碼錯誤
          //   this.$notify({title: '警告', message: response.data.message, type: 'warning'});
          //   this.$dialog.loading.close();
          // }
          // else if(response.data.code === 'ERROR_ACCOUNT')
          // {//賬號錯誤
          //   this.$notify({title: '警告', message: response.data.message, type: 'warning'});
          //   this.$dialog.loading.close();
          // }
          // else if(response.data.code === 'ERROR_AUTHRULE')
          // {
          //   this.$notify({title: '警告', message: response.data.message, type: 'warning'});
          //   this.$dialog.loading.close();
          // }
        }
      });
    },
    logout()
    {
      this.$dialog.loading.open();
      this.axios.post(this.IP + this.PATH + '/logout', {}).then(response => {
        if(response.data.code === "SUCCESS")
        {

        }
        else
        {
          if(response.data.message)
          {
            this.$notify({
              title: '警告',
              message: response.data.message,
              type: 'warning'
            });
          }
        }
        this.$dialog.loading.close();
      });
    },
    goRecord()
    {
      var url = "http://beian.miit.gov.cn";
      window.open(url, "_blank");
    }
  },
  watch: {
    accountId()
    {
      if(this.accountId === window.localStorage.getItem(this.localStorageAccountId))
      {
        this.isMind = true;
      }
      else
      {
        this.isMind = false;
      }
    }
  }
}
</script>
<style scoped lang="less">
.head {
  height: .70rem;
  font-size: .25rem;
  padding-left: 2.63rem;
  line-height: .80rem;
  background: #fff url(images/index_logo.png) no-repeat center left .72rem;
  background-size: 1.46rem 0.6rem;
  position: relative;
}

.head .size {
  font-size: .12rem;
  color: #00a0e9;
  position: absolute;
  line-height: .80rem;
  right: 3.00rem;
}

.centent {
  min-height: 600px;
  height: calc(calc(100vh - .70rem) - 1rem);
  background: url(images/index_back.jpg) no-repeat center;
  background-position: left center;
  background-size: 100% 100%;
  position: relative;
}

.centent .logo_box {
  width: 4.10rem;
  border-radius: .03rem;
  background: #fff;
  position: absolute;
  top: 2rem;
  right: 2.00rem;
  padding-bottom: .20rem;
}

.centent .logo_box .box_name {
  font-size: .18rem;
  padding: .30rem 0 .20rem .37rem;
}

.centent .logo_box .input_div {
  width: 3.30rem;
  height: .50rem;
  border: 1px #ccc solid;
  border-radius: 3px;
  margin-left: .37rem;
  margin-bottom: .10rem;
  position: relative;
}

.centent .logo_box .input_div img {
  width: .17rem;
  height: .20rem;
  vertical-align: middle;
  position: absolute;
  left: .15rem;
  top: .15rem;
}

.centent .logo_box .input_div input {
  box-sizing: border-box;
  margin: 0;
  border: 0;
  width: 100%;
  height: 100%;
  padding-left: .50rem;
}

.centent .logo_box .auth_code {
  width: 3.30rem;
  height: .50rem;
  line-height: .50rem;
  margin-left: .37rem;
  margin-bottom: .10rem;
}

.centent .logo_box .auth_code img {
  width: 1.30rem;
  margin-top: .06rem;
  cursor: pointer;
  float: right;
}

.centent .logo_box .auth_code input {
  width: 1.80rem;
  height: .38rem;
  padding-left: .50rem;
  background: url("images/auth_code.png") no-repeat .13rem center;
  box-sizing: border-box;
  border: 1px solid #ccc;
  margin: 0;
}

.centent .logo_box .forget_account {
  padding-left: .37rem;
  padding-right: .37rem;
  position: relative;
}

.centent .logo_box .forget_account .pane {
  display: inline-block;
  width: .14rem;
  height: .14rem;
  border: 1px solid #999;
  box-sizing: border-box;
  border-radius: 2px;
  margin-right: .05rem;
  position: relative;
  text-align: center;
  font-size: .10rem;
  font-weight: bold;
}

.centent .logo_box .forget_account .pane.right {
  background: url("images/right.png") no-repeat;
  background-size: 100% 100%;
}

.centent .logo_box .forget_account span {
  font-size: .14rem;
  vertical-align: middle;
}

.centent .logo_box .forget_account .forget_pad {
  position: absolute;
  right: .37rem;
  color: rgba(69, 100, 172, 0.8);
}

.centent .logo_box .button {
  width: 3.30rem;
  height: .44rem;
  font-size: .16rem;
  color: #fff;
  line-height: .44rem;
  border-radius: 3px;
  background: #007cc2;
  text-align: center;
  margin: 0 auto;
  margin-top: .20rem;
  cursor: pointer;
}

.centent .logo_box .apply_for {
  text-align: center;
  margin-top: .10rem;
}

.centent .logo_box .apply_for span {
  color: rgba(7, 49, 144, 0.8);
}

.bottom_box {
  /*height: 139rem;*/
  background: #0171b0;
  text-align: center;
  padding-top: .30rem;
  height: 1rem;
  overflow: hidden;
  /*padding-bottom: 10rem;*/
}

.bottom_box .hint {
  font-size: .16rem;
  color: #fff;
  padding-bottom: .20rem;
  cursor: pointer;
}

.bottom_box .hint .name {
  padding-left: .20rem;
}

.bottom_box .hint .vertical {
  padding: 0 .40rem;
}


</style>



// WEBPACK FOOTER //
// src/views/login.vue